import { useState } from 'react';
import Snackbar from '@mui/material/Snackbar';
import MuiAlert from '@mui/material/Alert';
import { formatDateWithTimezoneDisplay, isValidDateValue, formatDynamicScalar } from 'utils/dateFormat';
// import { useNavigate } from 'react-router-dom';
import {
  Typography,
  Grid,
  Box,
  Stack,
  List,
  ListItem,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  IconButton,
  Tooltip,
  Button
} from '@mui/material';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import AttachFileIcon from '@mui/icons-material/AttachFile';
import useApi from 'hooks/useApi';
import { useNavigate } from 'react-router';
import useSelection from 'hooks/useSelection';
// import { Search } from '@mui/icons-material';
const PriorityTransactions = ({
  transactionData,
  loading,
  fetchPriorityTransactions,
  statusFilter = 'all', // Added status filter prop with default value
  reportingStatus
}: {
  transactionData: any;
  loading: boolean;
  fetchPriorityTransactions: () => void;
  statusFilter?: 'all' | 'PRIORITY' | 'ALERT';
  reportingStatus:any
}) => {
  const [confirmOpen, setConfirmOpen] = useState(false);
  const [pendingTx, setPendingTx] = useState<any>(null);

  // Store selected fields as array of objects { question, uid }
  const { updateNotificationStatus } = useApi();

  const { selectedTeam, selectedClient } = useSelection();

  const navigate = useNavigate();

  // Helper function to format resource objects for display
  const formatResourceValue = (value: any): string => {
    if (Array.isArray(value) && value.length > 0) {
      const firstItem = value[0];
      // Check if it's actually a resource object (has 'fields' property)
      if (typeof firstItem === 'object' && firstItem !== null && firstItem.fields && Object.keys(firstItem.fields).length > 0) {
        // Display first 2 resources
        const resourcesToShow = value.slice(0, 2);
        const resourceStrings = resourcesToShow.map((resource: any) => {
          if (resource.fields && Object.keys(resource.fields).length > 0) {
            // Show first 2 fields from each resource
            return Object.values(resource.fields)
              .slice(0, 2)
              .map(v => String(v))
              .join(', ');
          }
          return 'Resource';
        });

        const result = resourceStrings.join(' | ');
        return value.length > 2 ? result + ' ...' : result;
      }
    }
    // Not a resource array, return as-is for other handling
    return String(value);
  };

  //   useEffect(()=>{
  //     if (selectedTeam)
  // fetchFlowData()
  //   },[selectedTeam])
  //   const fetchFlowData = async () => {
  //     if (!selectedTeam) return;
  //     try {
  //       const flowResp = await getFlowByTeamUid(selectedTeam);
  //        if (flowResp?.data?.steps) {
  //         setFieldOptions(flowResp.data.steps);
  //     //   }
  
  //        }
  //     } catch (error) {
  //       console.error('Error fetching team flow data:', error);
  //     }
  //   };

  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMsg, setSnackbarMsg] = useState('');
  const [snackbarSeverity, setSnackbarSeverity] = useState<'success' | 'error'>('success');
  const getBorderColor = (status: string | null | undefined): string => {
    if (!status || typeof status !== 'string') {
      return 'secondary.dark';
    } else if (status === "ALERT") {
      return 'accent.dark'; // Using theme's error color
    } else if (status === "PRIORITY") {
      return 'accent.main'; // Using theme's warning color
    }
    switch (status.toLowerCase()) {
      case 'cancelled':
      case 'failed':
        return '#f44336'; // Red
      case 'delivered':
      case 'completed':
        return '#4caf50'; // Green
      case 'in-transit':
      case 'in_progress':
        return '#ff9800'; // Orange
      case 'pending':
      case 'uploaded':
        return '#2196f3'; // Blue
      default:
        return '#9c27b0'; // Purple
    }
  };

  
  function formatToLocalTime(value: any) {
    console.log(value,'value data');
    return formatDateWithTimezoneDisplay(value); // No time, but includes timezone if available
  }
  const handleAcknowledge = async (tx: any) => {
    if (tx?.notificationuid) {
      try {
        await updateNotificationStatus(tx.notificationuid, false);
        // await fetchPriorityTransactions();
        setSnackbarMsg('Transaction acknowledged successfully');
        setSnackbarSeverity('success');
        setSnackbarOpen(true);
      } catch (err) {
        setSnackbarMsg('Failed to acknowledge transaction');
        setSnackbarSeverity('error');
        setSnackbarOpen(true);
      }
    }
  };

   const renderAlertTransactionContent = () => {
    if (!transactionData?.rows || transactionData.rows.length === 0) {
      return (
        <Box
          sx={{
            flex: 1,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            flexDirection: "column",
            bgcolor: "grey.50",
            borderRadius: 2,
            border: "2px dashed",
            borderColor: "grey.300",
            minHeight: 200,
            py: 8,
          }}
        >
          <Typography variant="h6" sx={{ color: "text.secondary", fontWeight: 500 }}>
            No Priority Transactions Found
          </Typography>
          <Typography variant="body2" sx={{ color: "text.secondary", mt: 1 }}>
            All transactions are up to date
          </Typography>
        </Box>
      );
    }

    // Get all field headings for alignment reference
    return transactionData.rows.map((txn: any, idx: number) => {
      // Determine which fields to display - get keys from additionalFields object
      const displayFields =
        txn?.additionalFields && typeof txn.additionalFields === 'object'
          ? Object.keys(txn.additionalFields)
          : [];
      return (
        <Box
          key={idx}
          onClick={() =>
            navigate(`/transactions/details/${txn?.team?.uid}/${txn?.uid}/${txn?.key}`)
          }
          sx={{
              position: 'relative',
              border: '1px solid',
              borderColor: getBorderColor(txn.notificationStatusType),
              borderRadius: 2,
              p: 1,
              mb: 1,
              bgcolor: (theme) => txn.notificationStatusType === 'ALERT'
                ? `${theme.palette.accent.dark}50`
                : txn.notificationStatusType === 'PRIORITY'
                  ? `${theme.palette.accent.main}50`
                  : 'white !important',
              cursor: 'pointer',
              transition: 'all 0.2s ease-in-out',
              '&:hover': {
                boxShadow: '0 4px 12px rgba(0,0,0,0.1)',
                borderColor: getBorderColor(txn.notificationStatusType),
                bgcolor: (theme) => txn.notificationStatusType === 'ALERT'
                ? `${theme.palette.accent.dark}50`
                : txn.notificationStatusType === 'PRIORITY'
                  ? `${theme.palette.accent.main}50`
                  : 'white !important',
              },
            }}
        >
          <Grid container spacing={1} alignItems="flex-start" sx={{ pr: 6 }}>
            {/* Dynamic Fields */}
            {displayFields.map((field: any, i: number) => {
              const value = (txn?.additionalFields as Record<string, unknown>)?.[field];

              return (
                <Grid item xs={6} md={2} key={i}>
                  <Box>
                    <Typography
                      variant="caption"
                      sx={{
                        fontSize: '0.65rem',
                        fontWeight: 600,
                        color: 'text.secondary',
                        textTransform: 'uppercase',
                      }}
                    >
                      {field}
                    </Typography>
                    <Typography
                      variant="body2"
                      sx={{
                        fontSize: '0.8rem',
                        fontWeight: 500,
                        color: 'text.primary',
                        wordBreak: 'break-word',
                      }}
                    >
                      {value !== undefined && value !== null && value !== ""
                        ? Array.isArray(value)
                          ? (value.length > 0 && typeof value[0] === 'object' && value[0] !== null && 'fields' in value[0])
                            ? formatResourceValue(value)
                            : value.map(v => formatDynamicScalar(v)).join(", ")
                          : isValidDateValue(value)
                            ? formatToLocalTime(value)
                            : String(value)
                        : "-"}
                    </Typography>
                  </Box>
                </Grid>
              );
            })}

            {(txn?.key && (txn?.team?.transactionFieldSelect?.length === 0) || !txn?.team?.transactionFieldSelect) && (
              <Grid item xs={6} md={2}>
                <Box>
                  <Typography
                    variant="caption"
                    sx={{ fontSize: "0.65rem", fontWeight: 600, color: "text.secondary" }}
                  >
                    {txn?.team?.settings?.transactionLabel || "Auth Key"}
                  </Typography>
                  <Typography
                    variant="body2"
                    sx={{ fontSize: "0.75rem", fontWeight: 500, color: "text.primary" }}
                  >
                    {txn?.key || "-"}
                  </Typography>
                </Box>
              </Grid>
            )}
            {/* Step Status */}
            {txn?.team?.displayStepStatus && (
              <Grid item xs={6} md={2}>
                <Box>
                  <Typography
                    variant="caption"
                    sx={{
                      fontSize: '0.65rem',
                      fontWeight: 600,
                      color: 'text.secondary',
                      textTransform: 'uppercase',
                    }}
                  >
                    Activity Status
                  </Typography>
                  <Typography variant="body2" sx={{ fontSize: '0.8rem', fontWeight: 500 }}>
                    {txn?.displayStatus || '-'}
                  </Typography>
                </Box>
              </Grid>
            )}

            {/* Reporting Status */}
            {txn?.team?.reportingStatus && txn?.keyStatus && (
            <Grid item xs={6} md={2}>
              <Box>
                <Typography
                  variant="caption"
                  sx={{
                    fontSize: '0.65rem',
                    fontWeight: 600,
                    color: 'text.secondary',
                    textTransform: 'uppercase',
                  }}
                >
                  Status
                </Typography>
                <Typography variant="body2" sx={{ fontSize: '0.8rem', fontWeight: 500 }}>
                  {reportingStatus?.[txn?.keyStatus] || '-'}
                </Typography>
              </Box>
            </Grid>
          )}

            {/* Process */}
            {txn?.team && (
              <Grid item xs={6} md={2}>
                <Box>
                  <Typography
                    variant="caption"
                    sx={{
                      fontSize: '0.65rem',
                      fontWeight: 600,
                      color: 'text.secondary',
                      textTransform: 'uppercase',
                    }}
                  >
                    Process
                  </Typography>
                  <Typography variant="body2" sx={{ fontSize: '0.8rem', fontWeight: 500 }}>
                    {txn?.team?.name || '-'}
                  </Typography>
                </Box>

              </Grid>
            )}
            <Grid item xs={6} md={2}>
              <Box>
                <Typography
                  variant="caption"
                  sx={{
                    fontSize: "0.65rem",
                    fontWeight: 600,
                    textTransform: "uppercase",
                    color: txn.notificationStatusType === 'ALERT'? 'error.main': 'error.main'
                  }}
                >
                  {txn.notificationStatusType === 'ALERT' ? 'Alert Reason' : 'Notification Reason'}
                </Typography>
                {txn?.notificationReasons && txn?.notificationReasons?.length > 0 ? (
                    <Box component="div" sx={{ pl: 2 }}>
                      <List component="ol" sx={{
                        listStyleType: 'decimal',
                        pl: 1,
                        m: 0,
                        '& li': {
                          display: 'list-item',
                          pl: 0.5,
                          fontSize: "0.82rem",
                          fontWeight: 500,
                          color: "text.primary",
                          lineHeight: 1.2,
                        }
                      }}>
                        {txn?.notificationReasons.map((reason: string, index: number) => (
                          <ListItem key={index} sx={{
                            p: 0,
                            m: 0,
                            display: 'list-item'
                          }}>
                            {reason}
                          </ListItem>
                        ))}
                      </List>
                    </Box>
                  ) : (
                    <Typography
                      variant="body2"
                      sx={{
                        fontSize: "0.82rem",
                        fontWeight: 500,
                        color: "text.primary",
                        lineHeight: 1.2,
                      }}
                    >
                      {txn?.notificationTitle || "-"}
                    </Typography>
                  )}

              </Box>
            </Grid>


          </Grid>
          <Box
            sx={{
              position: 'absolute',
              right: 8,
              top: '50%',
              transform: 'translateY(-50%)',
              display: 'flex',
              alignItems: 'center',
              gap: 0.5,
            }}
          >
            {/* File Icon - Show if file_Attachment is true */}
            {txn?.file_Attachment && (
              <IconButton
                sx={{
                  color: '#000000',
                  bgcolor: 'transparent',
                  marginRight: 0.5,
                  '&:hover': {
                    bgcolor: 'rgba(0, 0, 0, 0.08)',
                  }
                }}
                size="medium"
                // disabled
              >
                <AttachFileIcon fontSize="small" />
              </IconButton>
            )}

            {/* Acknowledge Button */}
            <Tooltip title="Acknowledge" placement="top">
              <IconButton
                onClick={(e) => {
                  e.stopPropagation();
                  setPendingTx(txn);
                  setConfirmOpen(true);
                }}
                sx={{
                  bgcolor: 'success.main',
                  color: 'white',
                  '&:hover': {
                    bgcolor: 'success.dark',
                    transform: 'scale(1.1)'
                  },
                  transition: 'all 0.2s',
                  boxShadow: '0 2px 4px rgba(0, 127, 64, 0.2)'
                }}
                size="small"
              >
                <CheckCircleOutlineIcon fontSize="small" />
              </IconButton>
            </Tooltip>
          </Box>


        </Box>
      );
    });
  };

  return (
    <>
      <Snackbar
        open={snackbarOpen}
        autoHideDuration={3000}
        onClose={() => setSnackbarOpen(false)}
        anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
      >
        <MuiAlert elevation={6} variant="filled" onClose={() => setSnackbarOpen(false)} severity={snackbarSeverity} sx={{ width: '100%' }}>
          {snackbarMsg}
        </MuiAlert>
      </Snackbar>


      <Box>
        {!selectedClient || !selectedTeam ? (
          <Box
            sx={{
              width: '100%',
              py: 8,
              textAlign: 'center',
              bgcolor: 'grey.50',
              borderRadius: 2,
              border: '2px dashed',
              borderColor: 'grey.300',
              minHeight: 300
            }}
          >
            <Typography variant="h6" color="text.secondary" sx={{ fontWeight: 500 }}>
              Please select a client and process to view priority transactions
            </Typography>
          </Box>
        ) : (
          <Box
            sx={{
              maxHeight: 'calc(100vh - 345px)',
              overflowY: 'auto',
              overflowX: 'hidden',
              pr: 0.5,
              '&::-webkit-scrollbar': {
                width: '6px'
              },
              '&::-webkit-scrollbar-track': {
                background: 'transparent'
              },
              '&::-webkit-scrollbar-thumb': {
                background: '#d0d0d0',
                borderRadius: '10px'
              },
              '&::-webkit-scrollbar-thumb:hover': {
                background: '#a8a8a8'
              }
            }}
          >
            <Stack spacing={1.5}>
              {loading ? (
                <Box
                  sx={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    flexDirection: 'column',
                    bgcolor: 'grey.50',
                    borderRadius: 2,
                    border: '2px dashed',
                    borderColor: 'grey.300',
                    height: 'calc(100vh - 345px)',
                    py: 4
                  }}
                >
                  <Typography variant="body1" sx={{ color: 'text.secondary', fontWeight: 500 }}>
                    Loading priority transactions...
                  </Typography>
                </Box>
              ) : (
                renderAlertTransactionContent()
              )}
            </Stack>
          </Box>
        )}
      </Box>
      <Dialog
        open={confirmOpen}
        onClose={() => {
          setConfirmOpen(false);
          setPendingTx(null);
        }}
        maxWidth="xs"
        fullWidth
        PaperProps={{
          sx: {
            borderRadius: 3,
            p: 2,
            bgcolor: "background.paper",
            boxShadow: "0px 6px 22px rgba(0,0,0,0.15)",
          },
        }}
      >
        {/* HEADER */}
        <DialogTitle
          sx={{
            fontWeight: 700,
            fontSize: "1rem",
            textAlign: "left",
            pb: 1,
          }}
        >
          Confirm Acknowledge
        </DialogTitle>

        {/* CONTENT */}
        <DialogContent sx={{ pt: 0, pb: 1 }}>
          <Stack spacing={1.4}>
            {/* Transaction Key */}
            <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
              <Typography
                variant="caption"
                color="text.secondary"
                sx={{ fontWeight: 600, whiteSpace: "nowrap" }}
              >
                {pendingTx?.team?.settings?.transactionLabel || "-"}:
              </Typography>

              <Box
                sx={{
                  border: "1px solid",
                  borderColor: "grey.300",
                  borderRadius: 1.5,
                  px: 0.8,
                  py: 0.35,
                  fontSize: "0.82rem",
                  fontWeight: 600,
                  bgcolor: "grey.50",
                  minWidth: 60,
                  textAlign: "center",
                }}
              >
                {pendingTx?.key || "-"}
              </Box>
            </Box>

            {/* Reasons */}
            <Box>
              <Typography
                variant="caption"
                color="text.secondary"
                sx={{ fontWeight: 600 }}
              >
                {pendingTx?.notificationStatusType === "ALERT"
                  ? "Alert Reasons"
                  : "Priority Reasons"}
              </Typography>

              {pendingTx?.notificationReasons?.length ? (
                <List
                  dense
                  component="ol"
                  sx={{
                    listStyleType: "decimal",
                    pl: 2,
                    "& .MuiListItem-root": {
                      display: "list-item",
                      pl: 0,
                      fontSize: "0.8rem",
                      py: 0.15,
                    },
                  }}
                >
                  {pendingTx.notificationReasons.map((reason: string, i: number) => (
                    <ListItem key={i}>{reason}</ListItem>
                  ))}
                </List>
              ) : (
                <Typography variant="body2" color="text.secondary">
                  {pendingTx?.notificationTitle || "No reasons provided"}
                </Typography>
              )}
            </Box>

            {/* Note */}
            <Typography
              variant="body2"
              color="text.secondary"
              sx={{
                fontSize: "0.78rem",
                textAlign: "left",
                mt: 0.5,
              }}
            >
              This transaction will be removed from your priority list. Do you wish to proceed?
            </Typography>
          </Stack>
        </DialogContent>

        {/* ACTION BUTTONS */}
        <DialogActions
          sx={{
            justifyContent: "flex-end",
            px: 2,
            pt: 0.5,
            pb: 1,
          }}
        >
          <Button
            variant="contained"
            size="small"
            sx={{
              textTransform: "none",
              fontWeight: 600,
              borderRadius: 2,
              px: 2.2,
              bgcolor: "#007f40",
              "&:hover": { bgcolor: "#006b36" },
            }}
            onClick={async () => {
              setConfirmOpen(false);
              setSnackbarMsg("Acknowledging transaction...");
              setSnackbarSeverity("success");
              setSnackbarOpen(true);
              if (pendingTx) await handleAcknowledge(pendingTx);
              setPendingTx(null);
              fetchPriorityTransactions();
            }}
          >
            Yes, Acknowledge
          </Button>

          <Button
            variant="outlined"
            size="small"
            sx={{
              textTransform: "none",
              fontWeight: 600,
              borderRadius: 2,
              px: 2.2,
            }}
            onClick={() => {
              setConfirmOpen(false);
              setPendingTx(null);
            }}
          >
            Cancel
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default PriorityTransactions;